import { useSearchParams } from "react-router-dom";
import { decodeEmailConfirmationToken } from "@/shared/utils/emailConfirmationToken";

type UseEmailConfirmationDataResult = {
  email?: string;
  id?: string;
  rawToken?: string | null;
};

export function useEmailConfirmationData(): UseEmailConfirmationDataResult {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  if (!token) {
    return { rawToken: token };
  }

  const payload = decodeEmailConfirmationToken(token);

  if (!payload) {
    return { rawToken: token };
  }

  return {
    email: payload.email,
    id: payload.id,
    rawToken: token,
  };
}
